<div class="div-body">

    <div class="div-title">
        
        <p class="p-title">
            Deseja Sair?
        </p>

    </div>

    <div class="div-SimNao">
        
        <p class="p-SimNao">
            Escolha "Não" para continuar no Menu Atendimento.
            <br/>
            Escolha "Sim" para voltar à tela de Login do sistema.
        </p>
        
    </div>

    <div class="div-botoes">

        <button mat-raised-button color="accent" class="b-botoes" (click)="close()">
            Não
        </button>

        <button mat-raised-button color="primary" class="b-botoes" (click)="logout()">
            Sim
        </button>
    </div>

</div>